// @flow
import type { State } from '../../../types';

export const configSelector = (state: State) => {
    return state.config && state.config.data && state.config.data.tisPlayer || {};
};